import { render, staticRenderFns } from "./Animation.vue?vue&type=template&id=53f563c9&scoped=true"
import script from "./Animation.vue?vue&type=script&lang=js"
export * from "./Animation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f563c9",
  null
  
)

export default component.exports